import { render, staticRenderFns } from "./WhiteCardCustomerService.vue?vue&type=template&id=e900a38e&scoped=true"
import script from "./WhiteCardCustomerService.vue?vue&type=script&lang=js"
export * from "./WhiteCardCustomerService.vue?vue&type=script&lang=js"
import style0 from "./WhiteCardCustomerService.vue?vue&type=style&index=0&id=e900a38e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e900a38e",
  null
  
)

export default component.exports